import PoliceDashboard from "../../../app/police-dashboard";
import PoliceIncidentDetail from "../../../app/police-dashboard/components/IncidentDetail";
import Settings from "../../../app/settings";

export const policeRoutes = [
    {
        category: "Dashboard",
        path: "/dashboard",
        icon: "ph-duotone ph-shield-star",
        title: "navigation.dashboard",
        component: <PoliceDashboard />,
        showInSidebar: false,
    },

    {
        path: "/incidents/:incidentId",
        component: <PoliceIncidentDetail />,
    },
];

